<script>
  import { onMount } from 'svelte';
  
  export let setPage;
  export let user = null; // 사용자 정보 추가
  export let isAdmin = false; // 관리자 여부 추가
  export let isCompany = false; // 기업 사용자 여부 추가
  
  // 상태 변수
  let apiKey = "";
  let prompt = "안녕하세요, 저는 테스트 중입니다. 간단한 인사말을 해주세요.";
  let response = "";
  let models = [];
  let selectedModel = "models/gemini-1.5-flash";
  let isLoading = false;
  let apiStatus = null;
  let isApiKeyVisible = false;
  let isMenuOpen = false; // 모바일 메뉴 상태 추가
  let isDropdownOpen = false; // 드롭다운 상태 추가
  
  // 컴포넌트 초기화 시 로컬 스토리지에서 사용자 정보 가져오기
  onMount(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        user = JSON.parse(storedUser);
        
        // 사용자 역할 확인
        isAdmin = user.role === 'admin' || user.email === 'admin@visionwide.kr';
        // 기업 사용자 확인
        isCompany = user.role === 'company';
      } catch (error) {
        console.error('사용자 정보 파싱 오류:', error);
      }
    }
  });
  
  // API 키 표시/숨김 토글
  function toggleApiKeyVisibility() {
    isApiKeyVisible = !isApiKeyVisible;
  }
  
  // 메뉴 토글 함수 추가
  function toggleMenu() {
    isMenuOpen = !isMenuOpen;
  }

  // 드롭다운 토글 함수 추가
  function toggleDropdown() {
    isDropdownOpen = !isDropdownOpen;
  }

  // 로그아웃 함수 추가
  function handleLogout() {
    // 로컬 스토리지에서 사용자 정보 및 토큰 삭제
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    isDropdownOpen = false;
    // 홈페이지로 이동
    setPage('home');
  }
  
  // 사용 가능한 모델 목록 조회
  async function listModels() {
    if (!apiKey) {
      apiStatus = {
        success: false,
        message: "API 키를 입력해주세요."
      };
      return;
    }
    
    try {
      isLoading = true;
      
      const response = await fetch("https://generativelanguage.googleapis.com/v1/models?key=" + apiKey);
      const data = await response.json();
      
      if (response.ok) {
        models = data.models.filter(model => 
          model.supportedGenerationMethods && 
          model.supportedGenerationMethods.includes("generateContent")
        );
        apiStatus = {
          success: true,
          message: "모델 목록을 성공적으로 불러왔습니다."
        };
      } else {
        apiStatus = {
          success: false,
          message: `오류: ${data.error?.message || "알 수 없는 오류가 발생했습니다."}`
        };
      }
    } catch (error) {
      console.error("API 호출 오류:", error);
      apiStatus = {
        success: false,
        message: `오류: ${error.message}`
      };
    } finally {
      isLoading = false;
    }
  }
  
  // Gemini API로 콘텐츠 생성
  async function generateContent() {
    if (!apiKey) {
      apiStatus = {
        success: false,
        message: "API 키를 입력해주세요."
      };
      return;
    }
    
    if (!prompt.trim()) {
      apiStatus = {
        success: false,
        message: "프롬프트를 입력해주세요."
      };
      return;
    }
    
    try {
      isLoading = true;
      response = "";
      
      const requestBody = {
        contents: [
          {
            parts: [
              {
                text: prompt
              }
            ]
          }
        ]
      };
      
      const apiResponse = await fetch(
        `https://generativelanguage.googleapis.com/v1/${selectedModel}:generateContent?key=${apiKey}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(requestBody)
        }
      );
      
      const data = await apiResponse.json();
      
      if (apiResponse.ok) {
        response = data.candidates[0].content.parts[0].text;
        apiStatus = {
          success: true,
          message: "API 키가 정상적으로 작동합니다! ✓"
        };
      } else {
        apiStatus = {
          success: false,
          message: `오류: ${data.error?.message || "알 수 없는 오류가 발생했습니다."}`
        };
      }
    } catch (error) {
      console.error("API 호출 오류:", error);
      apiStatus = {
        success: false,
        message: `오류: ${error.message}`
      };
    } finally {
      isLoading = false;
    }
  }
</script>

<div class="gemini-test-container">
  <header>
    <div class="logo">
      <button 
        on:click={() => setPage('home')}
        style="background: none; border: none; padding: 0; font: inherit; cursor: pointer; color: inherit;"
        class="logo-button"
      >
        <h1>WIDE-WORK</h1>
      </button>
    </div>
    <nav class="desktop-nav">
      <ul>
        <li><a href="#projects" on:click|preventDefault={() => setPage('home')}>프로젝트 찾기</a></li>
        <li><a href="/how-to-use" on:click|preventDefault={() => setPage('how-to-use')}>이용방법</a></li>
        {#if isAdmin}
          <li><a href="/admin-users" on:click|preventDefault={() => setPage('admin-users')}>회원 관리</a></li>
          <li><a href="/admin-project-applicants" on:click|preventDefault={() => setPage('admin-project-applicants')}>프로젝트별 지원자</a></li>
          <li><a href="/admin-all-applicants" on:click|preventDefault={() => setPage('admin-all-applicants')}>전체 지원자</a></li>
          <!-- <li><a href="/gemini-test" on:click|preventDefault={() => setPage('gemini-test')} class="active">Gemini 테스트</a></li> -->
          <li><a href="/project-register" on:click|preventDefault={() => setPage('project-register')}>공고 등록</a></li>
        {/if}
        {#if isCompany && !isAdmin}
          <li><a href="/company-applicants" on:click|preventDefault={() => setPage('company-applicants')}>지원자 관리</a></li>
          <li><a href="/project-register" on:click|preventDefault={() => setPage('project-register')}>공고 등록</a></li>
        {/if}
      </ul>
    </nav>
    <div class="auth-buttons">
      {#if user}
        <div class="user-dropdown">
          <button class="user-btn" on:click={toggleDropdown}>
            <span>{isAdmin ? '[관리자] ' : isCompany ? '[기업] ' : ''}{user.name || user.email.split('@')[0]}님</span>
            <span class="dropdown-arrow">▼</span>
          </button>
          {#if isDropdownOpen}
            <div class="dropdown-menu">
              <button on:click={() => setPage('mypage')}>마이페이지</button>
              {#if isAdmin}
                <button on:click={() => setPage('admin-users')}>회원 관리</button>
                <button on:click={() => setPage('admin-project-applicants')}>프로젝트별 지원자</button>
                <button on:click={() => setPage('admin-all-applicants')}>전체 지원자</button>
                <!-- <button on:click={() => setPage('gemini-test')}>Gemini 테스트</button> -->
                <button on:click={() => setPage('project-register')}>공고 등록</button>
              {/if}
              {#if isCompany && !isAdmin}
                <button on:click={() => setPage('company-applicants')}>지원자 관리</button>
                <button on:click={() => setPage('project-register')}>공고 등록</button>
              {/if}
              <button on:click={handleLogout}>로그아웃</button>
            </div>
          {/if}
        </div>
      {:else}
        <button class="login-btn" on:click={() => setPage('login')}>회원가입/로그인</button>
      {/if}
    </div>
    <button class="menu-btn" on:click={toggleMenu}>
      <span class="menu-icon">≡</span>
    </button>
  </header>

  <div class="mobile-menu" class:open={isMenuOpen}>
    <button class="close-btn" on:click={toggleMenu}>✕</button>
    <ul>
      {#if user}
        <li class="user-info">{isAdmin ? '[관리자] ' : isCompany ? '[기업] ' : ''}{user.name || user.email.split('@')[0]}님</li>
        <li><a href="/mypage" on:click|preventDefault={() => setPage('mypage')}>마이페이지</a></li>
        <li><a href="/home" on:click|preventDefault={() => setPage('home')}>프로젝트 찾기</a></li>
        <li><a href="/how-to-use" on:click|preventDefault={() => setPage('how-to-use')}>이용방법</a></li>
        {#if isAdmin}
          <li><a href="/admin-users" on:click|preventDefault={() => setPage('admin-users')}>회원 관리</a></li>
          <li><a href="/admin-project-applicants" on:click|preventDefault={() => setPage('admin-project-applicants')}>프로젝트별 지원자</a></li>
          <li><a href="/admin-all-applicants" on:click|preventDefault={() => setPage('admin-all-applicants')}>전체 지원자</a></li>
          <!-- <li><a href="/gemini-test" on:click|preventDefault={() => setPage('gemini-test')}>Gemini 테스트</a></li> -->
          <li><a href="/project-register" on:click|preventDefault={() => setPage('project-register')}>공고 등록</a></li>
        {/if}
        {#if isCompany && !isAdmin}
          <li><a href="/company-applicants" on:click|preventDefault={() => setPage('company-applicants')}>지원자 관리</a></li>
          <li><a href="/project-register" on:click|preventDefault={() => setPage('project-register')}>공고 등록</a></li>
        {/if}
        <li><a href="/logout" on:click|preventDefault={handleLogout}>로그아웃</a></li>
      {:else}
        <li><a href="/login" on:click|preventDefault={() => setPage('login')}>로그인/회원가입</a></li>
      {/if}
    </ul>
  </div>

  <div class="gemini-test-box">
    <div class="logo">
      <h1>Gemini API 테스트</h1>
    </div>
    
    <div class="api-key-section">
      <div class="form-group">
        <label for="api-key">API 키</label>
        <div class="input-group">
          {#if isApiKeyVisible}
            <input
              type="text"
              id="api-key"
              bind:value={apiKey}
              placeholder="Google Gemini API 키를 입력하세요"
            />
          {:else}
            <input
              type="password"
              id="api-key"
              bind:value={apiKey}
              placeholder="Google Gemini API 키를 입력하세요"
            />
          {/if}
          <button class="icon-button" on:click={toggleApiKeyVisibility}>
            {isApiKeyVisible ? '👁️' : '👁️‍🗨️'}
          </button>
        </div>
      </div>
      
      <div class="button-group">
        <button 
          class="primary-btn" 
          on:click={listModels} 
          disabled={isLoading || !apiKey}
        >
          {isLoading ? "로딩중..." : "모델 목록 조회"}
        </button>
      </div>
    </div>
    
    {#if models.length > 0}
      <div class="models-section">
        <label for="model-select">모델 선택</label>
        <select id="model-select" bind:value={selectedModel}>
          {#each models as model}
            <option value={model.name}>{model.name}</option>
          {/each}
        </select>
      </div>
    {/if}
    
    <div class="prompt-section">
      <div class="form-group">
        <label for="prompt">프롬프트</label>
        <textarea
          id="prompt"
          bind:value={prompt}
          rows="4"
          placeholder="테스트할 프롬프트를 입력하세요"
        ></textarea>
      </div>
      
      <div class="button-group">
        <button 
          class="primary-btn" 
          on:click={generateContent} 
          disabled={isLoading || !apiKey || !prompt.trim()}
        >
          {isLoading ? "생성 중..." : "콘텐츠 생성"}
        </button>
      </div>
    </div>
    
    {#if apiStatus}
      <div class="status-message" class:success={apiStatus.success} class:error={!apiStatus.success}>
        {apiStatus.message}
      </div>
    {/if}
    
    {#if response}
      <div class="response-section">
        <h3>API 응답</h3>
        <div class="response-content">
          {response}
        </div>
      </div>
    {/if}
    
    <div class="button-group bottom">
      <button class="secondary-btn" on:click={() => setPage('home')}>
        홈으로 돌아가기
      </button>
    </div>
  </div>

  <footer>
    <div class="company-info">
      <h3>주식회사 비전와이드</h3>
      <p>대표자명 : 최병영 | 사업자등록번호 : 134-87-40607 | 유료직업소개사업등록번호(국내): 제2026-3900373-14-5-00003호</p>
      <p>경기도 광명시 오리로854번길 12, 3층 304호(철산동, 세인트빌딩)</p>
      <p>TEL : 02-565-5747 | FAX : 02-6499-5747 | E-mail : admin@visionwide.kr</p>
      <p>©VISIONWIDE. ALL RIGHTS RESERVED.</p>
    </div>
  </footer>
</div>

<style>
  /* 헤더 스타일 */
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: white;
    border-bottom: 1px solid #e9ecef;
    position: sticky;
    top: 0;
    z-index: 100;
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
  }

  .logo h1 {
    color: #3273dc;
    font-size: 2rem;
    font-weight: 700;
    text-transform: none;
    cursor: pointer;
    margin: 0;
  }

  .desktop-nav {
    flex: 1;
    display: flex;
    justify-content: center;
  }

  .desktop-nav ul {
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .desktop-nav li {
    margin: 0 15px;
  }

  .desktop-nav a {
    color: #333;
    text-decoration: none;
    font-weight: 500;
    padding: 8px 0;
    position: relative;
  }

  :global(.desktop-nav a:hover),
  :global(.desktop-nav a.active) {
    color: #3273dc;
  }
  
  :global(.desktop-nav a.active)::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #3273dc;
  }
  
  .auth-buttons {
    display: flex;
    gap: 10px;
  }

  .login-btn {
    background-color: white;
    border: 1px solid #333;
    color: #333;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    font-size: 0.9rem;
  }
  
  .login-btn:hover {
    background-color: #f8f9fa;
  }
  
  .menu-btn {
    display: none;
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
  }
  
  .user-dropdown {
    position: relative;
  }
  
  .user-btn {
    display: flex;
    align-items: center;
    background-color: white;
    border: 1px solid #3273dc;
    color: #3273dc;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    font-size: 0.9rem;
  }
  
  .dropdown-arrow {
    font-size: 0.8rem;
    margin-left: 8px;
  }
  
  .dropdown-menu {
    position: absolute;
    top: 100%;
    right: 0;
    background-color: white;
    border: 1px solid #eee;
    border-radius: 4px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    width: 180px;
    margin-top: 8px;
    z-index: 100;
  }
  
  .dropdown-menu button {
    display: block;
    width: 100%;
    text-align: left;
    padding: 10px 15px;
    background: none;
    border: none;
    border-bottom: 1px solid #eee;
    cursor: pointer;
    font-size: 0.9rem;
  }
  
  .dropdown-menu button:last-child {
    border-bottom: none;
  }
  
  .dropdown-menu button:hover {
    background-color: #f5f5f5;
    color: #3273dc;
  }

  /* 모바일 메뉴 */
  .mobile-menu {
    display: none;
    position: fixed;
    top: 0;
    right: -300px;
    width: 300px;
    height: 100vh;
    background-color: white;
    box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
    transition: right 0.3s ease-in-out;
    z-index: 1000;
    padding: 20px;
  }

  .mobile-menu.open {
    right: 0;
  }

  .close-btn {
    background: none;
    border: none;
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 1.5rem;
    cursor: pointer;
  }

  .mobile-menu ul {
    list-style: none;
    margin-top: 60px;
  }

  .mobile-menu li {
    margin-bottom: 20px;
  }

  .mobile-menu a {
    color: #333;
    text-decoration: none;
    font-size: 1.2rem;
    font-weight: 500;
  }

  .user-info {
    font-weight: bold;
    color: #3273dc;
    padding: 0 0 10px 0;
    border-bottom: 1px solid #eee;
    margin-bottom: 15px;
  }

  .gemini-test-container {
    font-family: 'Noto Sans KR', sans-serif;
    background-color: #f9f9f9;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .gemini-test-box {
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    padding: 40px;
    width: calc(100% - 40px);
    max-width: 800px;
    margin: 40px auto;
  }
  
  .logo {
    text-align: center;
    margin-bottom: 30px;
  }
  
  .gemini-test-box .logo h1 {
    color: #4285F4;
    font-size: 2.2rem;
    font-weight: 700;
  }
  
  .form-group {
    margin-bottom: 20px;
  }
  
  label {
    display: block;
    font-size: 0.95rem;
    color: #555;
    margin-bottom: 8px;
    font-weight: 500;
  }
  
  input, textarea, select {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 1rem;
    transition: border-color 0.3s;
  }
  
  input:focus, textarea:focus, select:focus {
    border-color: #4285F4;
    outline: none;
  }
  
  .input-group {
    display: flex;
    gap: 10px;
  }
  
  .icon-button {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1.2rem;
  }
  
  .button-group {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-top: 20px;
  }
  
  .button-group.bottom {
    margin-top: 40px;
  }
  
  .primary-btn {
    background-color: #4285F4;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 12px 25px;
    font-size: 1rem;
    cursor: pointer;
    min-width: 150px;
  }
  
  .primary-btn:hover {
    background-color: #3367d6;
  }
  
  .primary-btn:disabled {
    background-color: #a0a0a0;
    cursor: not-allowed;
  }
  
  .secondary-btn {
    background-color: #f0f0f0;
    color: #666;
    border: none;
    border-radius: 5px;
    padding: 12px 25px;
    font-size: 1rem;
    cursor: pointer;
  }
  
  .secondary-btn:hover {
    background-color: #e0e0e0;
  }
  
  .api-key-section, .prompt-section, .models-section {
    margin-bottom: 30px;
    padding: 20px;
    border: 1px solid #eee;
    border-radius: 5px;
  }
  
  .status-message {
    padding: 12px;
    border-radius: 5px;
    margin-bottom: 20px;
    font-size: 0.95rem;
  }
  
  .status-message.success {
    background-color: #e6f4ea;
    color: #137333;
  }
  
  .status-message.error {
    background-color: #fce8e6;
    color: #c5221f;
  }
  
  .response-section {
    margin-top: 30px;
  }
  
  .response-section h3 {
    font-size: 1.2rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 15px;
  }
  
  .response-content {
    background-color: #f5f5f5;
    padding: 15px;
    border-radius: 5px;
    white-space: pre-wrap;
    font-family: 'Courier New', monospace;
    max-height: 300px;
    overflow-y: auto;
  }
  
  .models-section select {
    padding: 10px;
  }

  /* 푸터 스타일 */
  footer {
    background-color: #f8f9fa;
    color: #495057;
    padding: 40px 20px;
    margin-top: auto;
    border-top: 1px solid #e9ecef;
  }

  .company-info h3 {
    font-size: 1.2rem;
    margin-bottom: 15px;
    color: #495057;
  }

  .company-info p {
    margin-bottom: 8px;
    font-size: 0.9rem;
    color: #6c757d;
  }

  /* 반응형 스타일 */
  @media (max-width: 768px) {
    .desktop-nav, .auth-buttons {
      display: none;
    }

    .menu-btn {
      display: block;
    }

    .mobile-menu {
      display: block;
    }
    
    .gemini-test-box {
      padding: 20px;
      margin: 20px auto;
    }
  }
</style> 